import { produce } from "immer";
import { machineState_errors } from "../mealy/mealyErrorsInMachine";
export function machineProgramState_addState(machineState, position) {
    const newMachineState = produce(machineState, draftState => {
        const draftMachine = draftState.machine;
        const id = draftMachine.nextStateId.toString();
        draftMachine.nodes[id] = {
            id: id,
            name: id,
            posx: position.x,
            posy: position.y,
            isStart: false,
            isFinal: false,
            type: 'NodeRect',
            width: 30,
            height: 30,
        };
        draftMachine.nextStateId++;
    });
    return machineState_errors(newMachineState);
}
